import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { DefectCode, InspectionType } from '@Types';

export const fetchInspectionOverview = createAction(addNamespace('inspections/list'));

export const fetchInspectionOverviewResolved = createAction<InspectionType[]>(
	addNamespace('inspections/list/resolved'),
);

export const fetchInspectionOverviewRejected = createAction<string[]>(addNamespace('inspections/list/rejected'));

export const fetchInspectionStandardCodes = createAction<string>(addNamespace('inspections/codes/list'));

export const fetchInspectionStandardCodesResolved = createAction<{
	standard: string;
	codes: DefectCode[];
}>(addNamespace('inspections/codes/list/resolved'));

export const fetchInspectionStandardCodesRejected = createAction<{
	standard: string;
	error: string;
}>(addNamespace('inspections/codes/list/rejected'));
